export { default as base } from './base';
export { default as black } from './black';
export { default as light } from './light';
export { default as materiallight } from './materiallight';
export { default as materialdark } from './materialdark';
export { default as metro } from './metro';
export { default as colorsFromArray } from './colorsFromArray';
export { default as colorsFromObject } from './colorsFromObject';


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/themes/index.js
// module id = 1227
// module chunks = 0